import * as e from "react";
const c = (t) => /* @__PURE__ */ e.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ e.createElement("circle", { cx: 12, cy: 12, r: 12 }), /* @__PURE__ */ e.createElement("path", { d: "M10.6788 17.16L17.3577 6.83997H14.9857L10.221 14.1846L8.82701 11.6046H6.64233L10.1586 17.16H10.6788Z", fill: "white" }));
export {
  c as ReactComponent
};
